export const CEFR_ORDER = ["A1", "A2", "B1", "B2", "C1", "C2"];

export const B1_THRESHOLD = 70;
export const isB1 = (score) => (score ?? 0) >= B1_THRESHOLD;

export const DECISIONS = {
  pending: "Pending",
  accepted: "Accepted",
  rejected: "Rejected",
};

// Swiss: monochrome scale; the learner's own level is the only accent.
export const CEFR_ACCENT = "#ff8000";
export const CEFR_MUTED = "hsl(var(--muted-foreground) / 0.25)";
export const CEFR_COLORS = { A1: CEFR_ACCENT, A2: CEFR_ACCENT, B1: CEFR_ACCENT, B2: CEFR_ACCENT, C1: CEFR_ACCENT, C2: CEFR_ACCENT };

export const CEFR_LABELS = {
  A1: "Beginner",
  A2: "Elementary",
  B1: "Intermediate",
  B2: "Upper-Intermediate",
  C1: "Advanced",
  C2: "Proficient",
};

export const CEFR_TIPS = {
  A1: [
    "Practice everyday phrases: greetings, numbers, days of the week.",
    "Watch children's cartoons in English with subtitles.",
    "Learn 5 new words a day with a spaced-repetition app.",
  ],
  A2: [
    "Read short graded readers (Cambridge / Oxford A2).",
    "Practice writing 3-sentence journal entries daily.",
    "Have simple conversations about your routine and hobbies.",
  ],
  B1: [
    "Watch a 5-minute news clip and summarise it in your own words.",
    "Focus on connectors: however, because, although, in order to…",
    "Read one short news article a day and note new vocabulary.",
  ],
  B2: [
    "Read newspaper op-eds and identify the writer's argument.",
    "Practise expressing hypothetical situations with conditionals.",
    "Have 10-minute conversations on abstract topics: technology, ethics.",
  ],
  C1: [
    "Read long-form journalism (The Guardian, The Atlantic).",
    "Practise idioms and collocations in academic contexts.",
    "Write 300-word essays and get feedback on nuance and tone.",
  ],
  C2: [
    "Read literature and analyse tone, irony, and register.",
    "Debate abstract topics with native speakers.",
    "Sharpen precision: learn subtle differences between synonyms.",
  ],
};

export function formatDate(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export function formatDateTime(iso) {
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      year: "numeric", month: "short", day: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatDuration(seconds) {
  if (seconds == null) return "—";
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}m ${s}s`;
}
